import type * as Types from '@shared/types/graphqlGenerated.ts';

import * as Operations from './PopularProductsUnauthEmerson.query';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PopularProductsUnauthEmersonQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filters?: Types.InputMaybe<Types.ProductFilterObject>;
  isUnauthenticated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PopularProductsUnauthEmersonQuery = { viewer?: Types.Maybe<{ products: { pageInfo: Pick<Types.PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>, nodes?: Types.Maybe<Array<Types.Maybe<(
        Types.MakeOptional<Pick<Types.Product, 'id' | '_legacyId' | 'name' | 'slug' | 'description' | 'variantCount' | 'heatSensitive' | 'eqpLevel' | 'containsCbd'>, 'containsCbd'>
        & { brand: Pick<Types.Brand, 'id' | 'name'>, availableOrMasterVariant: Pick<Types.Variant, 'id' | 'descriptor' | 'image' | 'imageNew' | 'msrp' | 'sku' | 'emersonVariantId' | 'name' | 'isNew'> }
      )>>> } }> };



/**
 * __usePopularProductsUnauthEmersonQuery__
 *
 * To run a query within a React component, call `usePopularProductsUnauthEmersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularProductsUnauthEmersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularProductsUnauthEmersonQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      isUnauthenticated: // value for 'isUnauthenticated'
 *   },
 * });
 */
export function usePopularProductsUnauthEmersonQuery(baseOptions?: Apollo.QueryHookOptions<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>(Operations.PopularProducts_Unauth_Emerson_Query, options);
      }
export function usePopularProductsUnauthEmersonQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>(Operations.PopularProducts_Unauth_Emerson_Query, options);
        }
export function usePopularProductsUnauthEmersonQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PopularProductsUnauthEmersonQuery, PopularProductsUnauthEmersonQueryVariables>(Operations.PopularProducts_Unauth_Emerson_Query, options);
        }
export type PopularProductsUnauthEmersonQueryHookResult = ReturnType<typeof usePopularProductsUnauthEmersonQuery>;
export type PopularProductsUnauthEmersonQueryLazyQueryHookResult = ReturnType<typeof usePopularProductsUnauthEmersonQueryLazyQuery>;
export type PopularProductsUnauthEmersonQuerySuspenseQueryHookResult = ReturnType<typeof usePopularProductsUnauthEmersonQuerySuspenseQuery>;